<template>
  <main class="speakers">
    <div ref="hero">
      <Info class="u-hidden--from-ipadP" :allways="true"/>
      <AppTitle
        class="c-title--light"
        :data="{ content: 'Speakers' }"
        :isAnimated="false"
        data-item="title"
      />
      <AppLine data-item="line" :isAnimated="false"/>
      <AppTitle
        class="c-title--dark"
        :data="{ content: 'Unmissable Talks.' }"
        :isAnimated="false"
        data-item="title"
      />
      <AppLine data-item="line" :isAnimated="false"/>
    </div>

    <section class="speakers__grid-cont">
      <transition @enter="enter">
        <div class="speakers__grid" v-if="speakers.length > 0">
          <AppCard
            class="speakers__item"
            v-for="(speaker, key) in speakers"
            :key="key"
            :image="speaker.pictureUrl"
            :title="speaker.title"
            :alt="speaker.title"
            :description="speaker.subtitle"
            :actionLabel="'Discover Speaker'"
            :actionUrl="`/${$route.params.city}/speakers/${speaker.path}`"
            data-lazyanimation="picture"
          />
        </div>
      </transition>
    </section>

    <AppShowcase type="venues" />

    <AppSponsor :sponsorList="sponsors[$route.params.city]" />

    <AppFooter />
  </main>
</template>

<script>
import { mapGetters } from 'vuex';

import AppLine from '@/components/AppLine.vue';
import AppTitle from '@/components/AppTitle.vue';
import AppCard from '@/components/AppCard.vue';
import AppShowcase from '@/components/AppShowcase.vue';
import AppSponsor from '@/components/AppSponsor.vue';
import AppFooter from '@/components/AppFooter.vue';
import Info from '@/components/Info.vue';

import medusa from '@/scripts/medusa';
import { initials, animations } from '@/scripts/fx';

import speakersList from '@/assets/data/contents/speakers.json';
import sponsors from '@/assets/data/contents/sponsor.json';

export default {
  name: 'Speakers',
  components: {
    AppLine,
    AppTitle,
    AppCard,
    AppShowcase,
    AppSponsor,
    AppFooter,
    Info,
  },

  data() {
    return {
      speakersList,
      sponsors,
    };
  },
  computed: {
    ...mapGetters(['currentPage', 'contentReady', 'speakers']),

    firstCol() {
      const firstCol = [];

      if (this.currentPage() !== undefined) {
        this.currentPage().forEach((element, i) => {
          if (i % 3 === 1) firstCol.push(element);
        });
      }

      return firstCol;
    },
    speakers() {
      return this.speakersList[this.$route.params.city].speakers;
    },
  },
  mounted() {
    this.enterAnimation();
    medusa.recalculateTargets(this.$el);
  },
  methods: {
    enter(el, done) {
      const items = [...el.querySelectorAll('[data-lazyanimation]')];
      items.forEach(item => initials.get('picture')(item, 70));
      medusa.ref.pushToTarget('scrollAnimations', items);
      medusa.prevNodes.push(...items);
      done();
    },
    enterAnimation() {
      const titles = [...this.$refs.hero.querySelectorAll('[data-item="title"] h3')];
      const lines = [...this.$refs.hero.querySelectorAll('[data-item="line"]')];
      lines.forEach(line => initials.get('line')(line));
      titles.forEach(title => initials.get('title')(title));

      animations.get('title')(titles[0]);
      animations.get('line')(lines[0], 300);
      animations.get('title')(titles[1], 400);
      animations.get('line')(lines[1], 700);
    },
  },
  beforeDestroy() {
    medusa.removePrevTargets();
  },
};
</script>

<style lang="scss" scoped>
.speakers {
  .info {
    position: relative;
    top: unset;
    width: 100%;

    transform: translateY($unit-vh * -2);
    z-index: unset;
  }

  &__grid-cont {
    min-height: 50vh;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: $unit-vw * 6;
    grid-row-gap: $unit-vh * 4;
    padding: $unit-vh 0 0;

    @include mq($until: ds) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include mq($until: ipadP) {
      grid-template-columns: repeat(1, 1fr);
      grid-row-gap: $unit-vh * 6;
    }

    @include mq($until: ipadL) {
      grid-column-gap: $unit-vw * 4;
    }

    @include mq(ipadL) {
      padding: $unit-vh * 2 0 0;
    }
  }

  & ::v-deep .picture {
    @include aspect-ratio(11, 14);
  }
}
</style>
